import React, { useEffect } from 'react';
import { useHistory, useParams } from 'react-router';
import { useSelector } from 'react-redux';

// Constants
import QueryParamsConstants from 'Shared/constants/QueryParams.constants';
import { InputSources } from '../InputSources.constants';

// Types
import { IntegrationSources } from '../types';
import { SlackChannelType } from 'Shared/types/SlackChannel.type';

// Utils
import PageUrlsUtil from 'Shared/utils/PageUrls.utils';

// Hooks
import { useToggle, useQueryParam } from 'Shared/utils/hooks';
import { useUpdateAiSetting } from 'Shared/utils/hooks/use-update-ai-setting';

// Components
import SourceWrapper from './SourceWrapper';
import SelectSlackChannelsModal from 'Dashboard/components/SelectSlackChannelsModal/SelectSlackChannelsModal';

const SlackSource = () => {
  const history = useHistory();
  const { slug } = useParams();
  const { slackSourceConfiguration, handleUpdateAiSetting } = useUpdateAiSetting({ slug });

  const [showModalOnLoad] = useQueryParam(QueryParamsConstants.SHOW);
  const [isOpen, toggleIsOpen] = useToggle(false);

  const srcId = IntegrationSources.SLACK_AI;
  const source = InputSources.find(src => src.id === srcId);

  const count = slackSourceConfiguration?.length;
  const isSelected = count > 0;

  const slackAiDataSource =
    useSelector(state => state.data_sources.find(ds => ds.slug === srcId && ds.connected === true)) || {};
  const { connected } = slackAiDataSource;

  const oauthRedirectUrl = PageUrlsUtil.makeUpdateAiSettingPageUrl({ slug }) + `?${QueryParamsConstants.SHOW}=${srcId}`;

  const handleUpdate = (channels: SlackChannelType[]) => {
    handleUpdateAiSetting({ dataSources: { [srcId]: channels.map(chn => chn.id) } });
  };

  useEffect(() => {
    if (showModalOnLoad === source.id) {
      toggleIsOpen();
      history.push(PageUrlsUtil.makeUpdateAiSettingPageUrl({ slug }));
    }
  }, []);

  return (
    <>
      <SourceWrapper
        logo={source.logo}
        name={source.name}
        selected={isSelected}
        onClick={toggleIsOpen}
        connected={connected}
        connectedMsg={count > 1 ? `${count} Channels` : `${count} Channel`}
        selectMessage="Select Channels"
      />
      <SelectSlackChannelsModal
        isOpen={isOpen}
        toggleIsOpen={toggleIsOpen}
        selectedChannels={slackSourceConfiguration}
        onSelectChannel={handleUpdate}
        oauthRedirectUrl={oauthRedirectUrl}
        note="Select 2 - 3 channels for best results."
      />
    </>
  );
};

export default SlackSource;
